import React from 'react';
import { formatPrice, formatPaymentName, getTotalPaymentsFromType, extractYearFromDate, generateYearOptions, MONTHS } from '../../utils/helpers';

/**
 * Componente para mostrar y editar hitos de facturación en el Dashboard
 */
export const BillingMilestones = ({
  sample,
  onPaymentUpdate,
}) => {
  const paymentConfig = sample.payment_config;
  
  if (!paymentConfig || !paymentConfig.payments) return null;

  const baseYear = extractYearFromDate(sample.fecha_entrada) || String(new Date().getFullYear());
  const yearOptions = generateYearOptions(baseYear, 5);

  return (
    <div className="mt-4 p-4 bg-gray-50 rounded-lg border">
      <div className="flex justify-between items-center mb-3">
        <h4 className="text-sm font-semibold text-gray-700">Hitos de Facturación</h4>
        <span className="text-sm font-bold text-green-700">
          Total: €{formatPrice(paymentConfig.total_amount)}
        </span>
      </div>
      
      <div className="space-y-2">
        {paymentConfig.payments.map((payment, idx) => {
          const currentYear = payment.payment_year || baseYear;
          const totalPayments = getTotalPaymentsFromType(paymentConfig.payment_type);
          
          return (
            <div key={idx} className="flex items-center gap-3 p-2 bg-white rounded border">
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={payment.paid}
                  onChange={(e) => 
                    onPaymentUpdate(
                      sample.id, 
                      idx, 
                      e.target.checked, 
                      payment.payment_month || '', 
                      e.target.checked ? 'Pte facturar' : payment.billing_status,
                      currentYear
                    )
                  }
                  className="w-4 h-4 cursor-pointer"
                />
              </div>
              <div className="flex-1 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium">
                    {formatPaymentName(payment.payment_number, totalPayments)}
                  </span>
                  <span className={`text-sm font-semibold ${
                    payment.paid ? 'text-green-600' : 'text-gray-700'
                  }`}>
                    €{formatPrice(payment.amount)}
                  </span>
                </div>
                {payment.paid && (
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-gray-500">Año:</span>
                      <select
                        value={payment.payment_year || baseYear}
                        onChange={(e) => 
                          onPaymentUpdate(
                            sample.id, 
                            idx, 
                            true, 
                            payment.payment_month, 
                            payment.billing_status,
                            e.target.value
                          )
                        }
                        className="border rounded px-2 py-1 text-xs w-20"
                      >
                        {yearOptions.map((y) => (
                          <option key={y} value={y}>
                            {y}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-gray-500">Mes:</span>
                      <select
                        value={payment.payment_month || ''}
                        onChange={(e) => 
                          onPaymentUpdate(
                            sample.id, 
                            idx, 
                            true, 
                            e.target.value, 
                            payment.billing_status,
                            payment.payment_year || baseYear
                          )
                        }
                        className="border rounded px-2 py-1 text-xs w-32"
                      >
                        <option value="">Seleccionar</option>
                        {MONTHS.map((m) => (
                          <option key={m.value} value={m.value}>
                            {m.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-gray-500">Facturación:</span>
                      <select
                        value={payment.billing_status || 'Pte facturar'}
                        onChange={(e) => 
                          onPaymentUpdate(
                            sample.id, 
                            idx, 
                            true, 
                            payment.payment_month, 
                            e.target.value,
                            payment.payment_year || baseYear
                          )
                        }
                        className="border rounded px-2 py-1 text-xs w-32"
                      >
                        <option value="Pte facturar">Pte facturar</option>
                        <option value="Facturado">Facturado</option>
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="mt-2 text-xs text-gray-500">
        Tipo: {
          paymentConfig.payment_type === 'UNICO' ? 'Hito Único' :
          paymentConfig.payment_type === 'DOS_PAGOS' ? 'Dos Hitos (50%)' :
          paymentConfig.payment_type === 'TRES_PAGOS' ? 'Tres Hitos (50/25/25%)' :
          'Cuatro Hitos (25%)'
        }
      </div>
    </div>
  );
};

export default BillingMilestones;
